import React from 'react';

interface ProcessStepProps {
  number: string | number;
  title: string;
  description: string;
  icon?: string;
  className?: string;
  isLast?: boolean;
}

/**
 * Process step component — neumorphic theme
 */
const ProcessStep: React.FC<ProcessStepProps> = ({
  number,
  title,
  description,
  icon,
  className = '',
  isLast = false,
}) => {
  return (
    <div className={`relative flex gap-5 ${className}`}>
      {/* Step number circle — neumorphic extruded */}
      <div className="flex-shrink-0 flex flex-col items-center">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center font-display font-bold text-neu-accent text-lg"
          style={{
            background: '#E0E5EC',
            boxShadow: '6px 6px 12px rgb(163,177,198,0.6), -6px -6px 12px rgba(255,255,255,0.5)',
          }}
        >
          {number}
        </div>
        {/* Connector line */}
        {!isLast && (
          <div
            className="flex-grow w-0.5 mt-3"
            style={{ background: 'linear-gradient(to bottom, rgba(108,99,255,0.3), rgba(108,99,255,0.05))' }}
          />
        )}
      </div>

      {/* Content */}
      <div
        className="flex-1 mb-8 rounded-neu-sm p-5 bg-neu-bg"
        style={{
          boxShadow: '9px 9px 16px rgb(163,177,198,0.6), -9px -9px 16px rgba(255,255,255,0.5)',
        }}
      >
        <h3 className="font-display text-lg font-semibold mb-2 text-neu-text">{title}</h3>
        <p className="text-neu-muted text-sm leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default ProcessStep;
